import React, { useState, useEffect } from "react";
import { Input, Button, Form } from 'antd';
import { SearchOutlined } from "@ant-design/icons";
import { gqlBuilderWhere, helperFunc } from "utils";
import Icons from 'components/icons';
import { DrawerStandart, Localize } from "components/service";
import StandsGlobalForms from "../forms";
import { GLOBAL_STANDS_FILTER_FIELDS } from "../stands-global-const";

const { Search } = Input;

const StandsGlobalFilterDrawerContent = ({
    action,
    setCount,
    setFilters,
    setFilterList,
    filterList,
    standsGlobalFilters,
    form,
    filterTable
}) => (
    <>
        <strong className="modal-title">
            <Localize>FORMS.Title_Text_Filters</Localize>
        </strong>

        <StandsGlobalForms.Filter
            action={ action }
            setCount={ setCount }
            setFilters={ setFilters }
            setFilterList={ setFilterList }
            filterList={ filterList }
            gqlBuilderWhere={ gqlBuilderWhere }
            standsGlobalFilters={ standsGlobalFilters }
            form={ form }
            filterTable={ filterTable }
        />
    </>
);

const StandsGlobalTableFilter = ({
    setSearchText,
    searchText,
    setFilters = false,
    filters,
    standsGlobalFilters,
    setResetSorting = () => { },
    objOrderBy,
    filterTable = 'table-stands-global'
}) => {
    const [ form ] = Form.useForm();
    const [ filterList, setFilterList ] = useState({});
    const [ count, setCount ] = useState();

    const filterCount = helperFunc.countFilterList(count);

    /*eslint-disable */
    useEffect(() => {
        if (filters)
        {
            localStorage.setItem(`standsGlobalFilters-${ filterTable }`, JSON.stringify({ ...standsGlobalFilters, ...filterList }));
        } else
        {
            form.resetFields(GLOBAL_STANDS_FILTER_FIELDS);
        }

        if (searchText)
        {
            localStorage.setItem(`standsGlobalSearch-${ filterTable }`, JSON.stringify(searchText));
        } else
        {
            localStorage.removeItem(`standsGlobalSearch-${ filterTable }`);
            form.resetFields([ 'search' ]);
        }
    }, [ filters, searchText ]);

    useEffect(() => {
        if (standsGlobalFilters)
        {
            setCount(standsGlobalFilters);
        }
    }, []);
    /*eslint-enable */

    return (
        <Form
            key="filters-form"
            className="clear-css-prop table-filter-form"
            layout="vertical"
            form={ form }>

            <Form.Item
                initialValue={ searchText }
                name="search">

                <Search
                    className="filter-search"
                    prefix={ <SearchOutlined /> }
                    placeholder={ Localize({ children: "SEARCH.Input_Placeholder_GlobalStand" }).props.children }
                    onChange={ (e) => setSearchText(e.target.value) }
                />

            </Form.Item>

            <DrawerStandart
                width="287"
                extraClass={ 'modal-form filters' }
                modalButton={
                    <Button>
                        <Icons.Filter />
                        <span><Localize>FORMS.Button_Text_ApplyFilters</Localize></span>
                        { filterCount && <span className="filter-count">{ filterCount }</span> }
                    </Button>
                }
            >
                <StandsGlobalFilterDrawerContent
                    setCount={ setCount }
                    setFilters={ setFilters }
                    setFilterList={ setFilterList }
                    filterList={ filterList }
                    standsGlobalFilters={ standsGlobalFilters }
                    form={ form }
                    filterTable={ filterTable }
                />

            </DrawerStandart>

            <Button
                type="link"
                onClick={ () => {
                    setFilterList({});
                    setCount({});
                    setFilters(gqlBuilderWhere({}));
                    setSearchText('');
                    setResetSorting(objOrderBy);
                    localStorage.removeItem(`standsGlobalFilters-${ filterTable }`);
                    localStorage.removeItem(`standsGlobalSorting-${ filterTable }`);
                    localStorage.removeItem(`standsGlobalSearch-${ filterTable }`);
                } }
            >
                <span><Localize>FORMS.Button_Text_ResetFilters</Localize></span>
            </Button>
        </Form>
    );
};

export default StandsGlobalTableFilter;
